type Props = {
  brand?: string;
};

export const BrandsLogos = ({ brand }: Props) => {
  if (brand === "KTM") {
    return <img className="flex-none" src="https://partsfinder.clpstudio.ro/ktm.svg" style={{ height: 50, width: "auto" }} alt="Logo of the  KTM brand" />;
  } else if (brand === "HUSQVARNA") {
    return (
      <img
        className="flex-none"
        src="https://partsfinder.clpstudio.ro/husqvarna-logo.jpg"
        style={{ height: 60, width: "auto" }}
        alt="Logo of Husqvarna brand"
      />
    );
  } else if (brand === "GASGAS") {
    return (
      <img className="flex-none" src="https://partsfinder.clpstudio.ro/gasgas-logo.jpg" style={{ height: 60, width: "auto" }} alt="Logo of Gasgas brand" />
    );
  } else if (brand === "WP") {
    return <img className="flex-none" src="https://partsfinder.clpstudio.ro/wp-logo.svg" style={{ height: 60, width: "auto" }} alt="Logo of WP brand" />;
  } else {
    return (
      <img
        className="flex-none"
        src="https://partsfinder.clpstudio.ro/ktm-husqvarna-gasgas-logo.jpg"
        style={{ height: 60, width: "auto" }}
        alt="Logo of the KTM, Husqvarna and Gasgas brands"
      />
    );
  }
};
